module.exports = __webpack_public_path__ + "img/82140.f176b989.jpg";